import { CatHeading } from '@blocks-react/components/Heading';
import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CustomStyledLabel } from '../../../request-service';
type CatHeadingProps = ComponentProps<typeof CatHeading>;

export const CustomerAccountErrorHeading: FC<
  PropsWithChildren<CatHeadingProps>
> = ({ children, ...headingProps }) => (
  <CatHeading variant="label-lg" {...headingProps}>
    <CustomStyledLabel>{children}</CustomStyledLabel>
  </CatHeading>
);
